import axios from "./axios-decorator";

const baseAxiosUrl = window.location.origin;

/**
* Get bookings.
*/
export const getBookings = async (): Promise<any> => {
    let url = `${baseAxiosUrl}/api/bookings`;
    return await axios.get(url);
}

/**
* Get bookings services.
*/
export const getServices = async (bookingsId: string): Promise<any> => {
    let url = `${baseAxiosUrl}/api/bookings/services?bookingsId=${bookingsId}`;
    return await axios.get(url);
}